export const pbx = {
  name: 'pbx',
  title: 'pbx.breadcrumb.title',
  icon: () => import('@shared/components/icon/sidebar/icon-pbx.vue'),
  route: { name: 'pbx.module' },
  children: [
    {
      title: 'pbx.breadcrumb.service-package.index',
      route: { name: 'pbx.service-package.index' }
    },
    {
      title: 'pbx.breadcrumb.worksheet.index',
      route: { name: 'pbx.worksheet.index' }
    },
    {
      title: 'pbx.breadcrumb.operator.index',
      route: { name: 'pbx.operator.index' },
      routes: [
        { name: 'pbx.group.index' },
        { name: 'pbx.group.create' },

        { name: 'pbx.contact.index' },
        { name: 'pbx.contact.create' },

        { name: 'pbx.sip-account.index' },
        { name: 'pbx.sip-account.create' }
      ]
    },
    {
      title: 'pbx.breadcrumb.media.index',
      route: { name: 'pbx.media.index' }
    },
    {
      title: 'pbx.breadcrumb.phone-list.index',
      route: { name: 'pbx.phone-list.index' },
      routes: [{ name: 'pbx.phone-list.create' }]
    },
    {
      title: 'shared.breadcrumb.stats.title',
      route: { name: 'pbx.stats.type', params: { type: 'general' } }
    },
    {
      title: 'pbx.breadcrumb.time-condition.index',
      route: { name: 'pbx.time-condition.index' },
      routes: [{ name: 'pbx.time-condition.create' }]
    },
    {
      title: 'pbx.breadcrumb.number.index',
      route: { name: 'pbx.number.index' }
    },
    {
      title: 'pbx.breadcrumb.setting.index',
      route: { name: 'pbx.setting.index' }
    }
  ]
};
